export const JoyrideContent = ({ en, hi }) => {
  const isMobile = window.innerWidth <= 768;
  return (
    <div>
      <div style={{ fontWeight: 500, fontSize: isMobile ? "13px" : "inherit", lineHeight: isMobile ? "1.3" : "inherit" }}>{en}</div>
      <div
        style={{ fontWeight: 500, marginTop: isMobile ? "2px" : "4px", fontSize: isMobile ? "12px" : "inherit", lineHeight: isMobile ? "1.3" : "inherit" }}
      >
        {hi}
      </div>
    </div>
  );
};

export const getDemoTourSteps = () => [
  {
    target: ".class-step",
    content: (
      <JoyrideContent
        en="Please select a class to continue."
        hi="जारी रखने के लिए कृपया कक्षा चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: ".subject-step",
    content: (
      <JoyrideContent
        en="Please select a subject."
        hi="कृपया विषय चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: ".select-questions-step",
    content: (
      <JoyrideContent
        en="Please click the Select Questions button."
        hi="कृपया प्रश्न चुनें बटन पर क्लिक करें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableScrolling: true,
  },

  {
    target: ".true-false-step-3",
    content: (
      <JoyrideContent
        en="You are one step away from creating the paper. Please select True/False."
        hi="आप प्रश्नपत्र बनाने से एक कदम दूर हैं। कृपया सही/गलत चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".true-false-chapter-step-3",
    content: (
      <JoyrideContent
        en="Please select any chapter."
        hi="कृपया कोई अध्याय चुनें।"
      />
    ),
    placement: "auto",
  },
  {
    target: ".step-questions-3",
    content: (
      <JoyrideContent
        en="Select 5 questions."
        hi="5 प्रश्न चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },

  {
    target: ".fill-blanks-step-15",
    content: (
      <JoyrideContent
        en="Now select Fill in the Blanks."
        hi="अब रिक्त स्थान भरें चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".fill-blanks-chapter-step-15",
    content: (
      <JoyrideContent
        en="Select a chapter."
        hi="एक अध्याय चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".step-questions-15",
    content: (
      <JoyrideContent
        en="Select 5 questions."
        hi="5 प्रश्न चुनें।"
      />
    ),
    placement: "auto",
    disableBeacon: true,
  },

  {
    target: ".header-form-step",
    content: (
      <JoyrideContent
        en="You can change the header configuration here. Make sure there are no validation warnings."
        hi="यहाँ आप हेडर कॉन्फ़िगरेशन बदल सकते हैं। सुनिश्चित करें कि कोई वैधता चेतावनी न हो।"
      />
    ),
    placement: "auto",
    disableBeacon: true,
  },

  {
    target: ".submit-btn-final",
    content: (
      <JoyrideContent
        en="Click on Submit."
        hi="सबमिट पर क्लिक करें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },

  {
    target: ".print-button-step",
    content: (
      <JoyrideContent
        en="Click here to print the question paper."
        hi="प्रश्नपत्र प्रिंट करने के लिए यहाँ क्लिक करें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".download-button-step",
    content: (
      <JoyrideContent
        en="Click here to download the question paper as PDF."
        hi="प्रश्नपत्र को PDF के रूप में डाउनलोड करने के लिए यहाँ क्लिक करें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
  },
  {
    target: "#popup-step-anchor",
    content: (
      <JoyrideContent
        en="You have completed this part. Follow the instructions here."
        hi="आपने यह चरण पूरा कर लिया है। यहाँ दिए गए निर्देशों का पालन करें।"
      />
    ),
    placement: "bottom",
    disableBeacon: true,
    closeOnStep: true,
  },
];


export const getUserTourSteps = () => {
  const isMobile = window.innerWidth <= 768;
  return [
  {
    target: ".type-of-paper-step",
    content: (
      <JoyrideContent
        en="Choose Type Of Paper"
        hi="प्रश्नपत्र का प्रकार चुनें"
      />
    ),
    placement: isMobile ? "bottom-end" : "left",
    disableBeacon: true,
    disableScrolling: true,
    showNext: false,
    disableOverlay: true,
  },
  {
    target: isMobile ? ".maximun-marks-step-mobile" : ".maximun-marks-step",
    content: (
      <JoyrideContent
        en="Enter Maximum Marks Of Exam."
        hi="परीक्षा के अधिकतम अंक बताएं "
      />
    ),
    placement: isMobile ? "bottom" : "right",
    disableBeacon: true,
    showNext: true,
    disableOverlay: true,
  },
  {
    target: ".duration-step",
    content: (
      <JoyrideContent
        en="Enter Total Duration In Minutes"
        hi="कुल अवधि मिनट में बताएं "
      />
    ),
    placement: isMobile ? "bottom-end" : "left",
    disableBeacon: true,
    showNext: true,
    disableOverlay: true,
  },
  {
    target: isMobile ? ".exam-name-step-mobile" : ".exam-name-step",
    content: (
      <JoyrideContent
        en="Please Enter The Examination Name."
        hi="परीक्षा का नाम बताएं"
      />
    ),
    placement: isMobile ? "bottom-end" : "right",
    disableBeacon: true,
    showNext: true,
    disableOverlay: true,
  },
  {
    target: ".class-step",
    content: (
      <JoyrideContent
        en="Choose The Class"
        hi="कक्षा का चुनाव करें "
      />
    ),
    placement: isMobile ? "bottom-end" : "left",
    disableBeacon: true,
    disableScrolling: true,
    disableOverlay: true,
  },
  {
    target: ".subject-step",
    content: (
      <JoyrideContent
        en="Choose The Subject"
        hi="विषय का चुनाव करें"
      />
    ),
    placement: isMobile ? "bottom-end" : "right",
    disableBeacon: true,
    disableScrolling: true,
    disableOverlay: true,
  },
  {
    target: ".terms-and-conditions-step",
    content: (
      <JoyrideContent
        en="Enter Terms & Conditions If Any (Optional)"
        hi="नियम और शर्तें  बताएं ( यदि कोई है तो )"
      />
    ),
    placement: isMobile ? "bottom-end" : "right",
    disableBeacon: true,
    showNext: true,
    showSkip:true,
    disableOverlay: true,
  },
  {
    target: ".select-questions-step",
    content: (
      <JoyrideContent
        en="Please click the Select Questions button."
        hi="कृपया प्रश्न चुनें बटन पर क्लिक करें।"
      />
    ),
    placement: isMobile ? "bottom-end" : "right",
    disableBeacon: true,
    disableScrolling: true,
    disableOverlay: true,
  },
  {
    target: ".category-select-step",
    content: (
      <JoyrideContent
        en="Select a category to add questions."
        hi="प्रश्न जोड़ने के लिए एक श्रेणी चुनें।"
      />
    ),
    placement: "auto",
    disableBeacon: true,
      showSkip:true,
    disableOverlay: true,
  },
  {
    target: ".no-of-questions-step",
    content: (
      <JoyrideContent
        en="Enter Total No Of Questions"
        hi="इस भाग से कुल प्रश्न बताएं"
      />
    ),
    placement: "top",
    disableBeacon: true,
    showNext: true,
      showSkip:true,
    disableOverlay: true,
  },
  {
    target: ".marks-per-question-step",
    content: (
      <JoyrideContent
        en="Enter Marks per Question"
        hi="प्रत्येक प्रश्न के लिए अंक बताएं"
      />
    ),
    placement: "top",
    disableBeacon: true,
    showNext: true,
      showSkip:true,
    disableOverlay: true,
  },
  {
    target: ".chapter-select-step",
    content: (
      <JoyrideContent
        en="Please Select Chapter."
        hi="अध्याय का चुनाव करें"
      />
    ),
    placement: "auto",
    disableOverlay: true,
      showSkip:true,
    disableBeacon: true,
  },
  {
    target: ".questions-select-step",
    content: (
      <JoyrideContent
        en="Select questions as per the entered count."
        hi="पहले दर्ज की गई संख्या के अनुसार प्रश्न चुनें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableOverlay: true,
    showNext: true,
      showSkip:true,
  },
  {
    target: ".submit-btn-final",
    content: (
      <JoyrideContent
        en="Enter Submit to Complete"
        hi="पूरा करने के लिए सबमिट बट्टन दबाएं "
      />
    ),
    placement: "top",
    disableOverlay: true,

    disableBeacon: true,
  },
  {
    target: ".print-button-step",
    content: (
      <JoyrideContent
        en="Click here to print the question paper."
        hi="प्रश्नपत्र प्रिंट करने के लिए यहाँ क्लिक करें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableOverlay: true,
    showSkip:true,
    showNext: true,
  },
  {
    target: ".download-button-step",
    content: (
      <JoyrideContent
        en="Click here to download the question paper as PDF."
        hi="प्रश्नपत्र को PDF के रूप में डाउनलोड करने के लिए यहाँ क्लिक करें।"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableOverlay: true,
    showSkip:true,
    showNext: true,
  },
  {
    target: ".confirm-button-step",
    content: (
      <JoyrideContent
        en="Click here to save the question paper"
        hi="प्रश्नपत्र सहेजने के लिए यहाँ क्लिक करें"
      />
    ),
    placement: "top",
    disableBeacon: true,
    disableOverlay: true,

  },
  {
    target: ".my-question-view-step",
    content: (
      <JoyrideContent
        en="You can view your saved question papers here."
        hi="आप यहाँ अपने सहेजे गए प्रश्नपत्र देख सकते हैं।"
      />),
    placement: "top",
    disableBeacon: true,
    showNext: true,
        showSkip:true,
    disableOverlay: true,


  },
  {
    target: ".my-question-edit-step",
    content: (
      <JoyrideContent
        en="You can edit your saved question papers here."
        hi="आप यहाँ अपने सहेजे गए प्रश्नपत्र संपादित कर सकते हैं।"
      />),
    placement: "top",
    disableBeacon: true,
    isFinalStep: true,
    disableOverlay: true,

  },
  {
    target: ".my-worksheets-view-step",
    content: (
      <JoyrideContent
        en="You can view your saved worksheets here."
        hi="आप यहाँ अपने सहेजे गए कार्यपत्र देख सकते हैं।"
      />),
    placement: "top",
    disableBeacon: true,
    showNext: true,
        showSkip:true,
    disableOverlay: true,


  },
  {
    target: ".my-worksheets-edit-step",
    content: (
      <JoyrideContent
        en="You can edit your saved worksheets here."
        hi="आप यहाँ अपने सहेजे गए कार्यपत्र संपादित कर सकते हैं।"
      />),
    placement: "top",
    disableBeacon: true,
    isFinalStep: true,
    disableOverlay: true,


  },


];
};


